<template>
	<div>
		<div v-if="show">
			<div class="xinz">
				<template >
					<div class="right">
						<!--<el-button type="primary" style="" @click="storInAdd" v-if="canAdd"><i class="fa fa-plus" /> 新增</el-button>-->
						<router-link tag='a' :to="'/addStockin'" style="text-decoration: none;color: #fff;"><el-button type="warning" v-if="canAdd" ><i class="fa fa-plus" /> 新增</el-button></router-link>
					</div>
				</template>
			</div>
			<div>
				<el-form :inline="true"  class="demo-form-inline" size="small" @submit.native.prevent @keyup.native.enter="getWarehousing">
					<el-form-item label="搜索條件：">
						<el-input placeholder="入庫單" v-model="searchStorIn" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input placeholder="客戶/電話" v-model="searchName" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="searchSalesId"  filterable clearable placeholder="銷售員" >
							<el-option
									v-for="item in custSalesList"
									:key="item.id"
									:label="item.name"
									:value="item.id">
								<span style="float: left">{{ item.name }}</span>
								<span style="float: right; color: #8492a6; font-size: 13px;text-align: left;margin-left:10px;">{{ item.loginName }}</span>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getWarehousing"><i class="fa fa-search" />查詢</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="ind_main ind_main2">
				<div class="ind_cont2 ">
					<template>
						
						<el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
						            
						             
						              :data="warehousingList"
						              empty-text="无数据"
						              stripe
						              border
						              class="dataListTable">
						        <el-table-column
						                prop="scode"
						                align="left"
						                label="入庫單">
						        </el-table-column>
						        <el-table-column
						                prop="name"
						                align="left"
						                label="客戶">
										<template slot-scope="scope">
											{{scope.row.customer.code}},{{scope.row.customer.name}}
										</template>
						        </el-table-column>
						        <el-table-column
						                prop="customer.phone"
						                align="left"
						                label="電話">
						        
						        </el-table-column>
								<el-table-column
								        prop="sales"
								        align="left"
								        label="銷售員">
								
								</el-table-column>
								
								<el-table-column
								        prop="storInDate"
								        align="left"
								        label="時間">
								
								</el-table-column>
							
								
								
						        <el-table-column
						                prop="id"
						                width="100"
						                align="center"
						                label="操作">
						          <template slot-scope="scope">
                                    <el-button size="small" type="primary" @click.native="updateSelSotrIn(scope.row)" v-if="canEdit">
                                        <i class="fa fa-edit"/> 編輯
                                    </el-button>
						          </template>
						        </el-table-column>
						      </el-table>

						
						
						
						
						
						
						
					</template>
					<div class="pagination">
						<el-pagination
								layout="total, prev, pager, next"
								@current-change="handleCurrentChange"
								:current-page.sync="pager.page"
								:page-size="pager.size"
								:total="pager.total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<!--新增-->
		<div v-if="add" class="ind_main ind_main2">
			<el-form ref="form" :model="form" label-width="120px" >
				<div class="ind_cont rk_cont">
					<div class="ruku_top">
						<div class="ruku_from">
							<el-col :span="12">
								<el-form-item  label="工作單號 :" >
										<el-input size="medium" v-model="form.sCode" :disabled="form.sCodeShow" style="width: 65%" @blur="selSCode()"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="客戶編號 :" >
									<template v-if="form.codeShow"><span style="color: black;font-size: 16px;">{{form.code}}</span></template>
									<template v-else="">
										<el-autocomplete style="width: 65%" size="medium" :disabled="form.codeShow" v-on:input="addList(0,0,'cCode')"
														 class="inline-input"
														 v-model="form.code"
														 :fetch-suggestions="querySearch"
														 :trigger-on-focus="false"
														 @select="handleSelect"
										></el-autocomplete>
									</template>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item  label="姓  名 :">
									<span style="color: black;font-size: 16px;">{{form.name}}</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item  label="電  話 :" >
									<span style="color: black;font-size: 16px;">{{form.phone}}</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item  label="銷售員 :" >
									<span style="color: black;font-size: 16px;">{{form.sales}}</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item  label="地  址 :" >
									<span style="color: black;font-size: 16px;word-wrap: break-word;word-break: normal;">{{form.address}}</span>
								</el-form-item>
							</el-col>
							<el-col :span="12" style="text-align: right">
								<!--<template v-if="EDIT_STOR_IN">-->
									<!--<template v-if="!rkCont">-->
											<!--<el-button type="primary" :disabled="addShow" @click="addWarehousing">新 建</el-button>-->
									<!--</template>-->
								<!--</template>-->
							</el-col>
						</div>
					</div>
				</div>

				<div class="ruku_list">
					<el-form>
						<table cellspacing="0" cellpadding="0" class="responsive">
							<template v-for="(items,i) in addWarehousingList">
								<thead>
								<tr >
									<th colspan="4" style="text-align: left">
										<el-date-picker v-model="items.createDate" format="yyyy年MM月dd日 HH:mm"
														type="datetime" style="width: 40%" size="large">
										</el-date-picker>
									</th>
									<th >
										<span>第{{items.second}}次</span>
										<template v-if="items.storInItem.length === 0 || items.state === 0">
											<el-button icon="el-icon-delete" type="danger" circle @click="delAddWarehousingList(items,i)">刪除</el-button>
										</template>
									</th>
								</tr>
								<tr>
									<th width="12%">單位</th>
									<th width="10%">編號</th>
									<th width="40%">物品</th>
									<th width="10%">數量</th>
									<th >位置</th>
								</tr>
								</thead>
								<tr v-for="(item1,index) in items.storInItem" >
									<td width="12%">
										<template v-if="item1.state === 1">
											<span>{{item1.unit}}</span>
										</template>
										<template v-else="">
											<el-select v-model="item1.unit" @change="addList(i,index,'unit')" placeholder="請輸入" :disabled="item1.unitShow">
												<el-option
														v-for="item in company"
														:key="item.value"
														:label="item.label"
														:value="item.value">
												</el-option>
											</el-select>
										</template>
									</td>
									<td class="number" width="10%" >
										<template v-if="item1.state === 1">
											<span>{{item1.boxNo}}</span>
										</template>
										<template v-else="">
											<el-input style="width: 100%"  v-model="item1.boxNo" @change="addList(i,index,'boxNo')" :disabled="item1.boxNoShow" size="medium"
													  onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
										</template>
									</td>
									<td class="name" style="width: 40%;text-align: left;">
										<template v-if="item1.state === 1">
											<span>{{item1.item}}</span>
										</template>
										<template v-else="">
											<el-autocomplete :disabled="item1.itemShows" size="medium" v-on:input="addList(i,index,'item')" style="width: 85%"class="inline-input"
															 v-model="item1.item" :fetch-suggestions="querySearchRemark"
															 placeholder="請輸入內容"
															 @select="addList(i,index,'item')"
											></el-autocomplete>
										</template>
									</td>
									<td class="actions"  width="10%">
										<template v-if="item1.state === 1">
											<span>{{item1.qty}}</span>
										</template>
										<template v-else="">
											<el-input style="width: 100%" v-model="item1.qty" @focus="addList(i,index,'qty')" :disabled="item1.qtyShow"  size="medium"
													  onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input><!--只能輸入數字 e也不能-->
										</template>
									</td>
									<td class="actions">
										<template v-if="item1.state === 1">
											<el-col :span="16"><span>{{item1.value}}</span></el-col>
											<el-col :span="8"><span>已出倉</span></el-col>
										</template>
										<template v-else="">
											<el-col :span="16">
												<el-select :style="items.addStorIn==false?'float: left;':''"  size="medium" :disabled="item1.locationIdShows"
														   v-model="item1.value" default-first-option clearable
														   filterable remote reserve-keyword @change="handleSelectState($event,i,index)"
														   placeholder=""  @focus="isNullOptions4()"
														   :remote-method="remoteMethod"
														   :loading="tableloading">
													<el-option
															v-for="item in options4"
															:key="item.value"
															:label="item.label"
															:value="item.value">
													</el-option>
												</el-select>
											</el-col>
											<el-col :span="8">
												<template v-if="item1.state === 0">
													<el-button type="danger" size="small" circle @click="delStorInItem(i,index)">刪除</el-button>
												</template>
												<template v-else-if="item1.state === 1">
													<span>已出倉</span>
												</template>
											</el-col>
										</template>
									</td>
								</tr>
								<tr><td colspan="5"><br/></td></tr>
							</template>
						</table>
						<div class="rk_btn">
							<template v-if="canEdit">
								<el-button type="primary"  @click="submitStorIn" :disabled="!submitInfo" icon="el-icon-check" circle> 保存</el-button>
							</template>
							<el-button v-if="$store.getters.customerInSte == false" type="warning"  @click="cancelAdd" icon="el-icon-delete" circle> 取消</el-button>
							<el-button v-if="$store.getters.customerInSte"  type="warning"  @click ="retSearch" icon="el-icon-delete" circle> 返回</el-button>
						</div>
					</el-form>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
    import {getStorInList,getCIdList,getCustomerCodeList,insertStorIn,selStorInItem,getLocationByState,updateStorIn,getCustomerById,
        getSalesList,getStorInListId,getLocationBycusId,delStorInDate,delStorInItem,getAllRemarkList,selCode,getStaffAllList } from '../api/api'
    export default {
        data() {
            return{
                options4: [],
                salesList:[],//銷售員LIST
                saList:[],//銷售員LIST
                custSalesList:[],//銷售員LIST
                list: [],
                tableloading:false,
                warehousingList:[],
                storIn:[],//入庫詳細資訊
                customerCode:{},
                remarkList:[],//常用列表
                locationList:{},//架子表信息
				addNum:false,
				updateStorIn:"",
                codeList:[],
                company:[
                    {value:'籠',label:'籠'},
                    {value:'盒',label:'盒'},
                    {value:'板',label:'板'},
                    {value:'散件',label:'散件'},
                ], //單位
                storInId:0,
                typeId:1,
                addWarehousingList:[
                    {state:1,second:1,createDate:null,code:this.RndNum(),addStorIn:true,storInItem:[{addStorinItem:true,num:1,boxNo:1,item:'',qty:null,locationId:'',value:'',itemShows:true,qtyShow:true,locationIdShows:true}]},
                ],
                show:true,//資訊頁面
                add:false,//添加頁面
                rkCont:null,//入庫和客戶資訊
                submitInfo:true,//是否禁止保存按钮
                code:'',
                pager:{
                    page:0,
                    size:15,
                    total:0
                },
                form:{
                    id:null,
                    sCode:'',
                    code:null,
                    name:null,
                    phone:null,
                    address:null,
                    sales:null,
                    createDate:null,
                    sCodeShow:false,
                    codeShow:false,
                    nameShow:false,
                    phoneShow:false,
                    addressShow:false,
                    salesShow:false,
                },
                searchStorIn:'',
                searchName:'',
				searchSalesId:''
            }
        },
        methods: {
            handleSelectionChange(){},
            updateSelSotrIn(row){
                this.$router.push({
                    name:'編輯入倉',
                    params:{
                        id:row.id,
                        typeId:1,
						custId:0
                    }
                })
                var path="/updateStockin/"+row.id+"/"+1+"/"+0
                this.$router.push(path);
			},
            selSCode(){/*查詢入庫單是否重复*/
                selCode(this.form.sCode).then(data =>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        if(res.data !== null){//数据庫中没有当前入庫單號
                            if(res.data.code !== this.updateStorIn){//当前輸入的帐号是否是修改的帐号
                                this.$alert("當前入庫單號:"+this.form.sCode +" 已存在!", '提示', {
                                    confirmButtonText: '確定',
                                    type: 'warning',
                                    callback: action => {
                                        if(this.updateStorIn!==""){
                                            this.form.sCode=this.updateStorIn;
                                        }else{
                                            this.form.sCode="";
                                        }
                                    }
                                });
                            }
						}
                    }else{
                        this.$message.error(res.errmsg);
                    }
                })
			},
            retSearch(){	//返回搜索界面
                if(this.typeId==2){
                    this.$router.go(-1);
                }else{
                    this.$router.go(-1);
				}
            },
            remoteMethod(query) {/*選擇位置*/
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options4 = this.list.filter(item => {
                            return item.label.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options4 = [];
                }
            },
            remoteMethodSales(query) {/*選擇銷售員*/
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.saList = this.salesList.filter(item => {
                            return item.label.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options4 = [];
                }
            },
            clickLoad(){/*点击銷售員框时加载*/
				this.saList =[];
                this.saList = this.salesList;
			},
            handleCurrentChange(){
                this.getWarehousing();
            },
			isDate(){/*处理日期*/
                this.addWarehousingList.forEach((a,i) =>{
					if(a.createDate){
                        a.createDate= Math.round(new Date(a.createDate).getTime()/1000)//new Date(a.createDate*1000).Format("yyyy-MM-dd hh:mm")
					}
                })
			},
            isStringNull(){/*檢查是否為空*/
                let str="";
                if(this.form.sCode === null || this.form.sCode === "" || this.form.sCode===undefined){
                    return "入庫單不能為空"
                }if(this.form.code === null || this.form.code === ""){
                    return "客戶編號不能為空"
                }if(this.form.name === null || this.form.name === ""){
                    return "物品不能為空"
                }if(this.form.phone === null || this.form.phone === ""){
                    return "電話不能為空"
                }if(this.form.address === null || this.form.address === ""){
                    return "位址不能為空"
                }if(this.form.sales === null || this.form.sales === ""){
                    return "銷售員不能為空"
                }if(this.form.createDate === null || this.form.createDate === ""){
                    return "時間不能為空"
                }
                try {
                    this.addWarehousingList.forEach((a,i) =>{
                        if(a.createDate === null || a.createDate === ""){
                            str = "Job00"+(i + 1)+"的時間不能為空";
                            foreach.break = new Error(str);
                        }else {
                            a.storInItem.forEach((item,j) =>{
                                if(item.item === ""){
									a.storInItem.splice(j,1)//刪除當前這條沒有值的資料
                                }else {
                                    let num=0;
                                    if(this.addShow === true){//点击新建后把最前面的变为反的
										if(i === 0){
                                            num = this.addWarehousingList.length;
										}else{
										    num = i - 1;
										}
									}else {
                                        num = i + 1;
									}
                                    if(item.unit === null || item.unit === "" || item.unit ===undefined){
                                        str = "第"+ num +"次的單位不能為空";
                                        foreach.break = new Error(str);
                                    }if(item.boxNo === null || item.boxNo === 0){
                                        str = "第"+ num +"次的編號不能為空";
                                        foreach.break = new Error(str);
                                    }if(item.item === null || item.item === ""){
                                        str = "第"+ num +"次的名稱不能為空";
                                        foreach.break = new Error(str);
                                    }if(item.qty === null || item.qty === ""){
                                        str = "第"+ num +"次的數量不能為空";
                                        foreach.break = new Error(str);
                                    }if(item.locationId === null || item.locationId === ""){
                                        str = "位置不能為空";
                                        foreach.break = new Error(str);
                                    }
                                    item.qty = Number(item.qty);
                                }
                            });
                        }
                        let nary =this.addWarehousingList[i].storInItem.sort() ;//查找是否有重复的單位和BOX
                        var obj={};
                        var obj1={};
                        for(var j=0,l=nary.length;j<l;j++){
                            if(nary[j].state === 0){
                                if(obj[nary[j].boxNo+","+nary[j].unit]){
                                    if(obj1[nary[j].unit]){
                                        str = "有重複的單位: "+nary[j].unit+" ,和編號: "+nary[j].boxNo;
                                        foreach.break = new Error(str);
                                   }
                                }else{
                                    obj[nary[j].boxNo+","+nary[j].unit]=nary[j].boxNo+","+nary[j].unit;
                                    obj1[nary[j].unit]=nary[j].unit;
                                }
							}
                        }
                    });
                }catch (e){
                    return str;
                }
                return str;
            },
            getWarehousing(){/*查詢入庫*/
				this.submitInfo=true;
                this.tableloading=true;
                let params={page:this.pager.page,size:this.pager.size,storIn:this.searchStorIn.trim(),custName:this.searchName.trim(),salesId:this.searchSalesId};
                return getStorInList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.warehousingList=items;
                        this.warehousingList.forEach((a,b)=>{
                            a.storInDate = new Date(a.storInDate*1000).Format("yyyy-MM-dd hh:mm");
                            this.$set(this.warehousingList[b],'value',a.customer.code);//向陣列裡添加value欄位
                        });
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            addWarehousing(){/*點擊新增後向陣列添加一條資料*/
				this.addShow = true;
				let boxNo;
                this.addWarehousingList.forEach((item,i)=>{//查詢当前BOXNO 最大值 +1
                    let index = Number(this.addWarehousingList.length - 1);
                    let a = Number(this.addWarehousingList[index].storInItem.length -1);
                    boxNo= Number(this.addWarehousingList[index].storInItem[a].boxNo)+1;
				});
                this.addWarehousingList.unshift({state:0,second:this.addWarehousingList.length+1,createDate:new Date().Format("yyyy-MM-dd hh:mm:ss"),code:null,addStorIn:true,
                    storInItem:[{state:0,unitShow:false,num:1,addStorinItem:true,boxNo:boxNo,item:'',qty:null,locationId:'',value:'',boxNoShow:false,itemShows:true,qtyShow:true,locationIdShows:true}]});
            },
            querySearch(queryString, cb) {/*載入數據*/
                var restaurants =this.customerCode;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 調用 callback 返回建議清單的資料
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {/*選擇客編號後*/
                getCustomerById(item.id).then(data =>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        //console.log("resCUS",res);
                        let {id,code,name,phone,address,sales}=res.data[0];
                        this.form.id = id;
                        this.form.code =code;
                        this.form.name =name;
                        this.form.address =address;
                        this.form.phone =phone;
                        this.form.sales =sales;
                        if(id != undefined){
                            this.getLocationByCusId(id);
						}
                    }else{
                        this.$message.error(res.errmsg);
                    }
                })
            },
            querySearchRemark(queryString, cb) {/*載入常用列表數據*/
                var restaurants =this.remarkList;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 調用 callback 返回建議清單的資料
                cb(results);
            },
            selCustimerId(id){/*查詢客戶ID*/
                getStorInListId(id).then(data =>{
                    let {data:res={}}=data;
                    //console.log(res)
                    if(res.errcode===200){
                        let {id,code,name,phone,address}=res.data.customer;
                        this.form.id = id;
                        this.form.code =code;
                        this.form.name =name;
                        this.form.address =address;
                        this.form.phone =phone;
                        this.form.sales =res.data.sales;
                        this.form.sCode =res.data.scode;
                        if(id != undefined) {
                            this.getLocationByCusId(id);
                        }
                    }
                })
            },
            delAddWarehousingList(item,i){/*删除StorInDate表中数据*/
                this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if(this.addShow === true){
                        this.addWarehousingList.splice(i, 1);//删除数组
						this.addShow = false;
					}else{
                        return delStorInDate(item.id).then(str=> {//删除
                            let {data: res = {}} = str;
                            let mes="";
                            if (res.errcode === 200) {
                                this.addWarehousingList.splice(i, 1);//删除数组
                                mes="刪除成功"
                            }else{
                                mes="刪除失敗"
                            }
                            this.$message({
                                type: 'info',
                                message: mes
                            });
                        });
					}
                    //let id = this.addWarehousingList[i].id;
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刪除'
                    });
                });
			},
            delStorInItem(i,index){/*删除StorInItem表中数据*/
				this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    if (this.addWarehousingList[i].storInItem[index].addStorinItem === true) {
                        this.addWarehousingList[i].storInItem.splice(index, 1);//删除数据
                    } else {
                        let id = this.addWarehousingList[i].storInItem[index].id;
                        return delStorInItem(id).then(str => {//删除
                            let {data: res = {}} = str;
                            let mes = "";
                            if (res.errcode === 200) {
                                this.addWarehousingList[i].storInItem.splice(index, 1);//删除数据
                                mes = "刪除成功"
                            } else {
                                mes = "刪除失敗"
                            }
                            this.$message({
                                type: 'info',
                                message: mes
                            });
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消刪除'
                            });
                        })
                    }
                })
                //console.log("l",this.addWarehousingList[i].storInItem[index])
			},
            handleSelectState(id,i,index) {/*選擇位置後 向陣列添加一條新資料*/
                if(this.addWarehousingList[i].storInItem[index].num === 1){//
                    let box =Number(this.addWarehousingList[i].storInItem[index].boxNo);
                    this.addWarehousingList[i].storInItem.push({state:0,unitShow:false,unit:'',num:1,addStorinItem:true,boxNo:box+1,item:'',qty:null,locationId:'',value:'',itemShows:false,qtyShow:true,locationIdShows:true});
                }
                this.addWarehousingList[i].storInItem[index].num = 0;
                this.addWarehousingList[i].storInItem[index+1].unit = this.addWarehousingList[i].storInItem[index].unit;
				this.addWarehousingList[i].storInItem[index].locationId=id;//向選擇位置後的資訊添加位置ID
            },
            isNullOptions4(){/*点击时清空当前数组*/
                this.options4 = [];
                //this.getLocationByCusId(this.form.id);
			},
            selSotrIn(id,typeId){/*查詢入庫的詳細資訊*/
                this.$store.commit("setSearchSte",false);
                this.$store.commit("setCustomerInSte",false);
                this.selLocationState();//查詢架子
                this.add = true;
                this.show = false;
                this.addShow=false;
                this.rkCont = false;//入庫和客戶資訊
                this.storInId= id;
                this.typeId=typeId;
                let params={page:this.pager.page,size:100,storInId:id};
                return selStorInItem(params).then(str=>{//查詢當前入庫單裡有多少資料
                    let {data:res={}}=str;
                    //console.log("res",res);
                    if(res.errcode===200){
                        let leagueMap= new Map();
                        let cId;
                        let i=1;
                        res.data.data.forEach((item)=>{//重新處理下資料
                            this.form.createDate = new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm");
                            let itemList={};cId=item.cId;this.updateStorIn = item.sCode;
                            let floor;
                            if(item.floor === 0){ floor= "GF "+item.name; }else { floor=item.floor+"F "+item.name; }
                            if(item.state === 1){//是否是當天時間 不是當天的時間不能修改
                                itemList= {unitShow:true,unit:item.unit,num:0,addStorinItem:false,id:item.id,boxNo:item.boxNo,item:item.item,qty:item.qty,locationId:item.locationId,value:floor,state:item.state,
                                    itemShows:true,qtyShow:true,locationIdShows:true,boxNoShow:true};
                            }else{
                                itemList= {unitShow:false,unit:item.unit,num:0,addStorinItem:false,id:item.id,boxNo:item.boxNo,item:item.item,qty:item.qty,locationId:item.locationId,value:floor,state:item.state,
                                    itemShow:false,qtyShow:false,locationIdShow:false};
                            }
                            if(!leagueMap.has(item.storDateId)){//添加
                                let storIdItemList={state:1,second:i,id:item.storDateId,code:item.sCode,createDate:new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm:ss"),
									addStorIn:false,storInItem:[itemList]};
                                leagueMap.set(item.storDateId,storIdItemList);
                                i++;
                            }else{
                                leagueMap.get(item.storDateId).storInItem.push(itemList)
                            }
                        });
                        this.addWarehousingList =[... leagueMap.values()];
                        let boxNo;
                        this.addWarehousingList.forEach((item,i) =>{//查詢当前BOX 最大值 +1
							let index = Number(this.addWarehousingList.length - 1);
							let a = Number(this.addWarehousingList[index].storInItem.length -1);
							boxNo= Number(this.addWarehousingList[index].storInItem[a].boxNo)+1;
                            item.storInItem.push({state:0,unitShow:false,unit:'',num:1,addStorinItem:true,id:item.id,boxNo:boxNo+i,item:'',qty:null,locationId:'',value:'',
                                itemShows:true,qtyShow:true,locationIdShows:true})
						});
                        this.selCustimerId(id);//查詢客戶id
                        this.form.codeShow = true;
                        this.form.sCodeShow = false;
                        this.form.nameShow = true;
                        this.form.phoneShow = true;
                        this.form.addressShow = true;
                        this.form.salesShow = true;
                    }
                });

            },
            submitStorIn(){/*保存資料到資料庫*/
				this.submitInfo =false;//禁止保存按钮
                let str = this.isStringNull();
                let params={
                    code:this.form.sCode,
                    storInId:this.storInId,
                    customers:{
                        id:this.form.id,
                        code:this.form.code,
                        name:this.form.name,
                        address:this.form.address,
                        phone:this.form.phone,
                        sales:this.form.sales,
                        createDate:Math.round((new Date(this.form.createDate)).getTime()/1000)
                    },storInDateList:this.addWarehousingList};
                //console.log("pa",params); WHETHER_PUBLIC 当前架子是否公共使用(0不公用 1公用)
                if(str !== ""){
                    this.submitInfo = true;
                    this.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error',
							callback: action => {
								let boxNo;
								this.addWarehousingList.forEach((item,i) =>{//查詢当前BOX 最大值 +1
									let index = Number(this.addWarehousingList.length - 1);
									let a = Number(this.addWarehousingList[index].storInItem.length -1);
									boxNo= Number(this.addWarehousingList[index].storInItem[a].boxNo)+1;
									//console.log(item.storInItem[a]);
									if(item.storInItem[a].qty !== null || item.storInItem[a].locationId !== ""){
										item.storInItem.push({state:0,unitShow:false,unit:'',num:0,addStorinItem:true,id:item.id,boxNo:boxNo+i,item:'',qty:null,locationId:'',value:'',
											itemShows:true,qtyShow:true,locationIdShows:true})
									}
								});

                            }
                    });
                }else{
                    this.submitInfo = true;
                    this.isDate();
                    if(this.rkCont===true){//添加
                        return insertStorIn(params).then(data=>{
                            let {data:res={}}=data;
                            if(res.errcode===200){
                                this.$message({
                                    showClose: true,
                                    message: '入庫成功！',
                                    type: 'success'
                                });
                                this.cancelAdd();
                                this.getWarehousing();
                            }else{
                                this.$message.error(res.errmsg);
                                this.submitInfo = true;
							}
                        });
                    }else{//修改
                        return updateStorIn(params).then(data =>{
                            let {data:res={}}=data;
                            if(res.errcode===200){
                                this.$message({
                                    showClose: true,
                                    message: '修改成功！',
                                    type: 'success'
                                });
                                this.cancelAdd();
                                this.getWarehousing();
                              /*  if(this.typeId==2){

                                }*/
                            }else{
                                this.$message.error(res.errmsg);
                                this.submitInfo = true;
                            }
                        })
                    }
                }
            },
            RndNum(){//生成一個15位元數的數字
                let rnd="";
                for(let i=0;i<15;i++){
                    rnd+=Math.floor(Math.random()*10);
                }
                return rnd;
            },
            storInAdd(){/*顯示添加入庫資訊 關閉入庫資訊*/
                this.selLocationState();//查詢架子
                this.add = true;
                this.show = false;
                this.rkCont = true;
                this.nullList();
                this.form.createDate =new Date().Format("yyyy-MM-dd hh:mm");
                this.addWarehousingList[0].createDate=new Date().Format("yyyy-MM-dd hh:mm");
                //console.log(this.addWarehousingList);
            },
            cancelAdd(){/*顯示入庫資訊 關閉添加入庫資訊*/
                this.add = false;
                this.show = true;
                this.nullList();
                this.list=[];
                if(this.typeId==2){
                   /* this.$store.commit("setCustomerInSte", false);
                    this.$store.commit("closeTab",'stockin');
                    this.$router.go(-1);*/
                }
            },
            addList(i,index,str){/*修改是否能輸入*/
                if(str==="unit"){
                    this.addWarehousingList[i].storInItem[index].boxNoShow = false;
                    this.addWarehousingList[i].storInItem[index].itemShows = false;
                }if(str==="cCode"){
                    this.addWarehousingList[i].storInItem[index].unitShow=false;
                }if(str==="boxNo"){
                    this.addWarehousingList[i].storInItem[index].itemShows = false;
                }if(str==="item"){
                    this.addWarehousingList[i].storInItem[index].qtyShow = false;
                }if(str==="qty"){
                    this.addWarehousingList[i].storInItem[index].locationIdShows = false;
                }
            },
            selCutomerCode(){/*查詢客戶編號*/
                return getCustomerCodeList().then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.customerCode =res.data;
                        this.customerCode.forEach((a,b)=>{
                            this.$set(this.customerCode[b],'value',a.code);//向陣列裡添加value欄位
                        });
                    }
                });
            },
			letSalesList(){/*查詢銷售員LIST*/
                return getSalesList().then(data=>{
                    let {data:res={}}=data;
                    //console.log(res)
                    if(res.errcode===200){
                        this.salesList = res.data;
                        this.salesList.forEach((a,b)=>{
                            this.$set(this.salesList[b],'value',a.name);//向陣列裡添加value欄位
                        });
                    }
                });
			},
            selLocationState(){/*查詢位置資訊*/
                return getLocationByState(Number(0)).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.locationList=res.data;
                        let sotrOnMap= new Map();
                        this.locationList.forEach((a,b)=>{
                            if(a.floor === "0"){
                                sotrOnMap.set(b,{id:a.id,location:"GF "+a.name});
                            }else {
                                sotrOnMap.set(b,{id:a.id,location:a.floor+"F "+a.name});
                            }
                        });
                        let list =[... sotrOnMap.values()];
                        this.list = list.map(item => {
                            return { value: item.id, label: item.location };
                        });
                        //console.log("resL",this.list);
                    }
                });
            },
            getLocationByCusId(id){/*以客戶ID查詢當前客戶在用的架子*/
				if(this.storInId !== 0){//入庫單ID为空 没有架子
                    return getCIdList({id:this.storInId,cusId:id}).then(data=>{
                        let {data:res={}}=data;
                        if(res.errcode===200){
                            this.locationList=res.data;
                            let sotrOnMap= new Map();
                            this.locationList.forEach((a,b)=>{
                                if(a.floor === "0"){
                                    sotrOnMap.set(b,{id:a.id,location:"GF "+a.name});
                                }else {
                                    sotrOnMap.set(b,{id:a.id,location:a.floor+"F "+a.name});
                                }
                            });
                            let list =[... sotrOnMap.values()];
                            let Tlist =list.map(item => {
                                return { value: item.id, label: item.location };
                            });
                            let this_ = this;
                            let t1 = setInterval(function () {//定时器 3秒后加载到list
                                for(var i=0; i< Tlist.length;i++){
                                    this_.list.unshift(Tlist[i])
                                }
                                clearTimeout(t1);
                            },3000);
                        }
                    });
				}
            },
            getRemarkList(){/*查詢常用列表*/
				return getAllRemarkList(1).then(data =>{
					  let {data:res={}}=data;
					  if(res.errcode===200){
						  this.remarkList = res.data;
                          this.remarkList.forEach((a,b)=>{
                              this.$set(this.remarkList[b],'value',a.content);//向陣列裡添加value欄位
                          });
					  }
				});
			},
            nullList(){/*清空*/
                this.addWarehousingList =[
                    {state:1,second:1,createDate:null,code:null,addStorIn:true,storInItem:[{state:0,unitShow:true,unit:'',num:1,boxNo:1,item:'',qty:null,locationId:'',value:'',boxNoShow:true,itemShows:true,qtyShow:true,locationIdShows:true}]},
                ];
                this.form ={
                    id:null, code:null, name:null, phone:null, address:null, sales:null, createDate:null,sCode:''
                };
                this.updateStorIn="";
                this.storInId=0;
                //this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
            },
			test(){
                this.show=true;
                this.add = false;
			}
        },
        activated(){/*進入載入*/
            /*getStaffAllList().then(data=>{
                let {data:res={}}=data;
                this.custSalesList=res.data;
            });*/
            Date.prototype.Format = function (fmt) {
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小時
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S": this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            };
            this.getWarehousing();
            //this.cancelAdd();
            //this.selCutomerCode();
			//this.letSalesList();//查詢銷售員
            //this.getRemarkList();//常用列表
            // Math.round(new Date().getTime()/1000); js轉Unix
            //new Date(createDate*1000).Format("yyyy-MM-dd hh:mm:ss") Unix轉js

			//首页查詢功能
            if(this.$store.getters.warehouseSta == true){
//                this.$store.commit("setSearchSte",true);
                this.selSotrIn(this.$route.params.id,this.$route.params.typeId);
                this.$store.commit("setSearchSte",true);
            }

            //客戶详情編輯
            if(this.$store.getters.customerInSte == true){
//                this.$store.commit("setSearchSte",true);
                this.selSotrIn(this.$route.params.id,this.$route.params.typeId);
            }

        },
        computed:{
            canAdd(){
                return this.$store.getters.hasPermission("ADD_STOR_IN");
            },
            canEdit(){
                return this.$store.getters.hasPermission("EDIT_STOR_IN");
            },
		},
        watch:{
            '$route':'test'
        },
    }
</script>
<style>
	.xinz button{background:#4B78FF;border:none;margin-bottom:1rem;}
	.xinz button:hover{background:#4B78FF;color:#fff;}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{background-color:#aab5c5 }
	.el-form-item {
		margin-bottom: 5px;
	}
	/*.el-form-item__error{*/
		/*color: #f56c6c;*/
		/*font-size: 12px;*/
		/*line-height: 1;*/
		/*padding-top: 4px;*/
		/*position: absolute;*/
		/*top: 25%;*/
		/*left: 66%;*/
	/*}*/
</style>




// WEBPACK FOOTER //
// src/views/Warehousing.vue